import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Typography from "@mui/material/Typography";

export default function MemberNumberOfUsesCard({ numberOfUses }) {
  return (
    <CustomContainer
      sx={{
        alignItems: "center",
        borderRadius: "30px",
        display: "flex",
        height: "100px",
        justifyContent: "space-around",
      }}
    >
      <ShoppingCartIcon color="primary" sx={{ fontSize: "50px" }}/>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <Typography
          color="primary"
          component="p"
          sx={{ fontWeight: 600 }}
          variant="h4"
        >
          { numberOfUses }
        </Typography>
        <Typography sx={{ fontSize: '16px' }}>
          QUANTIDADE DE VISUALIZAÇŌES
        </Typography>
      </Box>
    </CustomContainer>
  );
};
